const DOC_MIME_TYPES = new Set([
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]);

/** Returns true if the attachment can be rendered inside the carousel */
export const isCarouselSupported = (mimeType?: string): boolean => {
  if (!mimeType) return false;
  if (DOC_MIME_TYPES.has(mimeType)) return false;
  return (
    mimeType.startsWith('image/') ||
    mimeType.startsWith('video/') ||
    mimeType.startsWith('audio/') ||
    mimeType === 'application/pdf' ||
    mimeType === 'text/plain'
  );
};
